import { Canales } from './Canales';
import { UsuarioDatos } from './UsuarioDatos';
export class DatosStorage {
    TokenAcceso: string;
    Recaptcha: string;
    UsuarioActivo: UsuarioDatos;
    AplicacionSeleccionado: number = 0;
    AliadoSeleccionado: number = 0;
    DescripcionAliadoSeleccionado: string = '';
    ListaCanales: Canales[] = [];
    CanalSeleccionado: number = 0;
    DescripcionCanalSeleccionado: string = '';
    RolMulticonsulta: boolean = false;
    RolEditarProductoCliente: boolean = false;
    RolEliminarProductoCliente: boolean = false;
    MostrarSedeconsulta: boolean = false;
    Componente: string = '';
    FechaExpiracion: Date;
    AplicacionSeleccionadoInicial: number = 0;
    AliadoSeleccionadoInicial: number = 0;
    DescripcionAliadoSeleccionadoInicial: string = '';
    CanalSeleccionadoInicial: number = 0;
    DescripcionCanalSeleccionadoInicial: string = '';
}